import { type ReactNode, useEffect } from "react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"
import { applyDesignTokensToRoot } from "@/lib/tokens"

type AppProvidersProps = {
  children: ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")

  useEffect(() => {
    applyDesignTokensToRoot()
  }, [])

  useEffect(() => {
    if (typeof window === "undefined" || !("scrollRestoration" in window.history)) {
      return
    }

    const previousScrollRestoration = window.history.scrollRestoration
    window.history.scrollRestoration = "manual"

    return () => {
      window.history.scrollRestoration = previousScrollRestoration
    }
  }, [])

  return (
    <>
      {children}
      {import.meta.env.PROD && !isLocalhost ? (
        <>
          <SpeedInsights />
          <Analytics />
        </>
      ) : null}
    </>
  )
}
